<template>
  <div class="rounded-md grid gap-12 bg-[white]/40 p-16">
    <p class="raw-heading-3">
      {{ i18n(translations.statement) }}
    </p>
    <p class="raw-heading-3 text-[--raw-verydarkgrey]">
      {{ i18n(translations.body) }}
    </p>
    <button
      type="button"
      class="raw-cta-3 rounded-full flex h-36 w-fit items-center gap-8 bg-[white] px-16 transition-colors duration-[var(--raw-fast)] ease-[var(--raw-ease-out-quart)] hover:bg-[color-mix(in_oklab,var(--raw-lightgrey)_75%,transparent)] active:bg-[color-mix(in_oklab,var(--raw-lightgrey)_75%,transparent)]"
      @click="handleClick()"
    >
      <RevIllustration
        src="/mine-my-phone/icons/heart--flat.svg"
        alt=""
        aria-hidden="true"
        :width="22"
        :height="22"
      />
      {{ i18n(translations.cta) }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'

import { useModalState } from '~/scopes/campaign/composables/useModalState'

import translations from './TakeActionCallout.translations'

// The call to action at the end of every story and every metal; two mount sites cover four
// surfaces, since `ArticleView` and `MetalDetail` are each shared by a panel and a reader.
const props = defineProps<{
  /** Tracking surface: `article-detail` / `article-extended` / `metal-detail`. */
  zone: string
}>()

const i18n = useI18n()
const { trackClick } = useTracking()
const { openAction } = useModalState()

function handleClick() {
  trackClick({
    zone: props.zone,
    name: 'take-action',
    campaign: 'raw-materials',
  })
  openAction()
}
</script>
